<button mat-icon-button class="close" (click)="close()"><mat-icon>clear</mat-icon></button>
<div class="tutorial">
  <div class="flex-right">
    <mat-checkbox [checked]="showNextTime" (change)="showNextTime = $event.checked;">Показывать инструкцию при входе</mat-checkbox>
  </div>
  <div class="tutorial__flex">
    <mat-dialog-content class="tutorial__body">
      <h2>{{ current.title }}</h2>
      <p [innerHtml]="html"></p>
    </mat-dialog-content>
    <div class="tutorial__media">
      <video #video *ngIf="current.video else onlyImage"
             [poster]="current.image"
             tabindex="0"
            [src]="current.video">
        <source [src]="current.video" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
      </video>
      <ng-template #onlyImage><img [src]="current.image"></ng-template>
    </div>
  </div>

  <mat-dialog-actions class="tutorial__flex">
    <div class="tutorial__link">
      <span (click)="openDetail()">Посмотреть подробную инструкцию</span>
    </div>
    <div class="tutorial__buttons">
        <button mat-icon-button class="arrows arrow-left" (click)="selectPrev()" [disabled]="currentIndex < 1" color="primary"><mat-icon>arrow_left</mat-icon></button>
        <button mat-icon-button class="arrows arrow-right" (click)="selectNext()" [disabled]="currentIndex > slides.length-2" color="primary"><mat-icon>arrow_right</mat-icon></button>
        <div class="tutorial__steps">
          <ng-container *ngFor="let slide of slides; let i=index; let last=last">
            <button mat-icon-button (click)="selectSlide(i)"
                    [ngClass]="{active: i==currentIndex, passed: i<currentIndex, future: i>currentIndex}">{{ i+1 }}</button>
            <div class="tutorial__steps__line" *ngIf="!last" [ngClass]="{future: i>=currentIndex}"></div>
          </ng-container>
      </div>
    </div>
  </mat-dialog-actions>
</div>
